//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
import setting from '@/setting';
export default {
  name: 'DashboardIndex',
  data: function data() {
    return {
      title: setting.projectName,
      today: dayjs().format('YYYY年MM月DD日 dddd'),
      quickActions: [{
        title: '会员管理',
        desc: '管理平台会员信息',
        icon: 'fa fa-users',
        route: '/member/memberManage'
      }, {
        title: '订单管理',
        desc: '查看和处理订单',
        icon: 'fa fa-list-alt',
        route: '/order/orderManage'
      }, {
        title: '结算配置',
        desc: '结算参数与奖金配置',
        icon: 'fa fa-cogs',
        route: '/config/balanceConfig'
      }, {
        title: '奖金日志',
        desc: '查看奖金发放记录',
        icon: 'fa fa-usd',
        route: '/finance/bonusLog'
      }, {
        title: '商品管理',
        desc: '管理平台商品信息',
        icon: 'fa fa-shopping-bag',
        route: '/product/proManage'
      }, {
        title: '推荐网',
        desc: '推荐关系网络',
        icon: 'fa fa-sitemap',
        route: '/relation/relationRecomment'
      }, {
        title: '链路图',
        desc: '链路关系图',
        icon: 'fa fa-share-alt',
        route: '/relation/relationLink'
      }]
    };
  },
  methods: {
    handleQuickAction: function handleQuickAction(action) {
      if (action.route) {
        this.$router.push(action.route).catch(function () {});
      }
    }
  }
};